import { Suspense, type PropsWithChildren } from 'react'

import { BuscaClienteSkeleton } from '@/components/busca-cliente-skeleton'
import { PageLayoutSkeleton } from '@/layouts/page'
import { ConfiguracoesParametrosSkeleton } from '@/pages/configuracoes/parametros/configuracoes-parametros.skeleton'
import { ConfiguracoesReservaSkeleton } from '@/pages/configuracoes/reserva/configuracoes-reserva.skeleton'
import { ConsultaLeadsRepresadosPageSkeleton } from '@/pages/consulta-leads-represados/skeleton'
import { DetalhesLeadRepresadoPageSkeleton } from '@/pages/detalhes-lead-represado/skeleton'

export const BuscarClientePageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <BuscaClienteSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const ConsultaLeadsRepresadosPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ConsultaLeadsRepresadosPageSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const DetalhesLeadRepresadoPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <DetalhesLeadRepresadoPageSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const ConfiguracoesReservaPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ConfiguracoesReservaSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const ConfiguracoesParametrosPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ConfiguracoesParametrosSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
